import React from 'react';

const Notfound = () => {
    return (
        <div className='flex h-[84vh] items-center justify-center'>
            <h1 className='text-3xl font-bold'>NOt Found</h1>
        </div>
    );
};

export default Notfound;